import { COMPANY } from "./helpers"
import CompanyHeader from "./CompanyHeader"
import TitleReference from "./TitleReference"
import "./pdf-preview.css"

const DocumentLayout = ({
  documentTitle = "",
  metaRows = [],
  showHeader = true,
  footerNote = `Thank you for choosing ${COMPANY.name.toUpperCase()}.`,
  padLayout = "tabular",
  children,
}) => (
  <div className="pdf-preview">
    <div className={`pdf-page pdf-layout-${padLayout}`}>
      <table>
        <tbody>
          <tr>
            <td className="pdf-w-60 pdf-vt">
              {showHeader && <CompanyHeader />}
            </td>
            <td className="pdf-w-40 pdf-vt">
              <TitleReference
                documentTitle={documentTitle}
                metaRows={metaRows}
              />
            </td>
          </tr>
        </tbody>
      </table>

      {children}

      {showHeader && footerNote && (
        <div className="pdf-footer-note">{footerNote}</div>
      )}
    </div>
  </div>
)

export default DocumentLayout
